export default "__VITE_ASSET__fb89b580__"